import { useTranslations } from 'use-intl';
import { LOCALE_NATIVE_NAMES, SUPPORTED_LOCALES } from '@financialharmony/i18n';
import { cn } from '@/lib/utils';
import { useUiLocale } from '@/i18n/useUiLocale';

/**
 * Language choice for a visitor who has not signed in: a small fixed toggle in the top-right corner
 * of the sign-in page. Before sign-in there is no account to save to, so it only remembers the choice
 * in this browser and cannot fail.
 */
export function AuthLanguageSwitch() {
  const t = useTranslations('common.language');
  const { locale, setLocale } = useUiLocale();

  return (
    <nav aria-label={t('label')} className="fixed right-4 top-4 z-10 flex items-center gap-2 text-sm">
      {SUPPORTED_LOCALES.map((code, index) => (
        <span key={code} className="flex items-center gap-2">
          {index > 0 && <span aria-hidden="true" className="text-muted-foreground">·</span>}
          <button
            type="button"
            lang={code}
            aria-current={code === locale ? 'true' : undefined}
            onClick={() => void setLocale(code)}
            className={cn(
              'rounded-sm px-1 py-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              code === locale ? 'font-semibold text-foreground' : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {LOCALE_NATIVE_NAMES[code]}
          </button>
        </span>
      ))}
    </nav>
  );
}
